import { styleEnd } from "../../algorithms/styleDirection";
import Lang from "../../userPreferences/staticWords";

export const discussIconAdd = (
  color,
  iconWidth,
  iconHeight,
  containerStyle
) => (
  <div className={`d-flex ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24.007"
    >
      <path
        id="fi-br-comments"
        d="M8.262,18H3.5A3.5,3.5,0,0,1,0,14.5V9.232A9.311,9.311,0,0,1,3.4,2.008,8.739,8.739,0,0,1,10.768.179a9.009,9.009,0,0,1,7.095,7.265A8.644,8.644,0,0,1,15.969,14.6,9.984,9.984,0,0,1,8.262,18ZM8.979,3A5.734,5.734,0,0,0,5.3,4.326,6.4,6.4,0,0,0,3,9.232V14.5a.5.5,0,0,0,.5.5H8.262a7,7,0,0,0,5.412-2.336,5.685,5.685,0,0,0,1.233-4.711,6.072,6.072,0,0,0-4.72-4.832A6.247,6.247,0,0,0,8.979,3Zm12,6.782a8.129,8.129,0,0,0-1-.687,10.553,10.553,0,0,1-.553,3.335A5.359,5.359,0,0,1,21,16.2v4.3a.5.5,0,0,1-.5.5H16.64a5.951,5.951,0,0,1-4.269-1.671,12.742,12.742,0,0,1-3.279.629,7.664,7.664,0,0,0,.716,1.021A8.853,8.853,0,0,0,16.64,24H20.5A3.5,3.5,0,0,0,24,20.5V16.2a8.267,8.267,0,0,0-3.017-6.416Z"
        transform="translate(0 0.006)"
        fill="#12aac4"
      />
      <text
        id="_"
        data-name="+"
        transform={
          Lang.getLanguage() === "ar"
            ? "translate(503.50 417.50)"
            : "translate(492 417)"
        }
        fill={`${color ?? "#12aac4"}`}
        fontSize="16"
        fontFamily="SegoeUI-Bold, Segoe UI"
        fontWeight="700"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
    </svg>
  </div>
);

export const layersIconAdd = (color, iconWidth, iconHeight, containerStyle) => (
  <div className={`d-flex ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${iconWidth ?? "60.154"}`}
      height={`${iconHeight ?? "60.314"}`}
      viewBox="0 0 44.154 40.314"
    >
      <g
        id="Group_304"
        data-name="Group 304"
        transform="translate(-465.846 -383.686)"
      >
        <g
          id="_007-layers"
          data-name="007-layers"
          transform="translate(465.846 383.686)"
        >
          <path
            id="Path_163"
            data-name="Path 163"
            d="M17.837,31.291a9.46,9.46,0,0,1-4.71-1.266L2.493,23.937a5.2,5.2,0,0,1,.024-8.894L13.178,9.026a9.4,9.4,0,0,1,9.318,0l10.661,6.018a5.2,5.2,0,0,1,.024,8.894L22.547,30.025a9.462,9.462,0,0,1-4.71,1.266Zm0-20.526a6.814,6.814,0,0,0-3.356.89L3.82,17.673a2.129,2.129,0,0,0-.01,3.644L14.444,27.4a6.766,6.766,0,0,0,6.785,0l10.634-6.087a2.129,2.129,0,0,0-.01-3.644L21.193,11.655A6.815,6.815,0,0,0,17.837,10.765ZM13.83,10.34h0Zm8.717,33.143L34.938,36.39a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,40.862a6.768,6.768,0,0,1-6.79,0L2.048,33.84a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Zm0-6.692L34.938,29.7a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,34.17a6.768,6.768,0,0,1-6.79,0L2.048,27.148a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Z"
            transform="translate(-0.001 -7.79)"
            fill={`${color ?? "#12aac4"}`}
          />
        </g>
        <g
          id="Ellipse_271"
          data-name="Ellipse 271"
          transform="translate(486 401)"
          fill="#edf4fd"
          stroke="#12aac4"
          strokeWidth="2"
        >
          <ellipse cx="12" cy="11.5" rx="12" ry="11.5" stroke="none" />
          <ellipse cx="12" cy="11.5" rx="11" ry="10.5" fill="none" />
        </g>
        <text
          id="_"
          data-name="+"
          transform={
            Lang.getLanguage() === "ar"
              ? "translate(503.50 417.50)"
              : "translate(492 417)"
          }
          fill={`${color ?? "#12aac4"}`}
          fontSize="16"
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </g>
    </svg>
  </div>
);

export const layersIconEdit = (
  color,
  iconWidth,
  iconHeight,
  containerStyle
) => (
  <div className={`d-flex ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${iconWidth ?? "60.154"}`}
      height={`${iconHeight ?? "60.314"}`}
      viewBox="0 0 44.154 40.314"
    >
      <g
        id="Group_304"
        data-name="Group 304"
        transform="translate(-465.846 -383.686)"
      >
        <g
          id="_007-layers"
          data-name="007-layers"
          transform="translate(465.846 383.686)"
        >
          <path
            id="Path_163"
            data-name="Path 163"
            d="M17.837,31.291a9.46,9.46,0,0,1-4.71-1.266L2.493,23.937a5.2,5.2,0,0,1,.024-8.894L13.178,9.026a9.4,9.4,0,0,1,9.318,0l10.661,6.018a5.2,5.2,0,0,1,.024,8.894L22.547,30.025a9.462,9.462,0,0,1-4.71,1.266Zm0-20.526a6.814,6.814,0,0,0-3.356.89L3.82,17.673a2.129,2.129,0,0,0-.01,3.644L14.444,27.4a6.766,6.766,0,0,0,6.785,0l10.634-6.087a2.129,2.129,0,0,0-.01-3.644L21.193,11.655A6.815,6.815,0,0,0,17.837,10.765ZM13.83,10.34h0Zm8.717,33.143L34.938,36.39a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,40.862a6.768,6.768,0,0,1-6.79,0L2.048,33.84a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Zm0-6.692L34.938,29.7a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,34.17a6.768,6.768,0,0,1-6.79,0L2.048,27.148a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Z"
            transform="translate(-0.001 -7.79)"
            fill={`${color ?? "#12aac4"}`}
          />
        </g>
        <g
          id="Ellipse_271"
          data-name="Ellipse 271"
          transform="translate(486 401)"
          fill="#edf4fd"
          stroke={`${color ?? "#12aac4"}`}
          strokeWidth="2"
        >
          <ellipse cx="12" cy="11.5" rx="12" ry="11.5" stroke="none" />
          <ellipse cx="12" cy="11.5" rx="11" ry="10.5" fill="none" />
        </g>
        <text
          id="_"
          data-name="+"
          transform={
            Lang.getLanguage() === "ar"
              ? "translate(502 421.50)"
              : "translate(494 421.50)"
          }
          fill="#12aac4"
          fontSize="16"
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            *
          </tspan>
        </text>
      </g>
    </svg>
  </div>
);

export const projectsIconAdd = (
  color,
  iconWidth,
  iconHeight,
  containerStyle
) => (
  <div className={`d-flex ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${iconWidth ?? "60.154"}`}
      height={`${iconHeight ?? "60.314"}`}
      viewBox="0 0 49.221 42.333"
    >
      <g
        id="Group_305"
        data-name="Group 305"
        transform="translate(-320.779 -381.667)"
      >
        <path
          id="projection-screen"
          d="M39.112,6.875V0H0V6.875H2.292V27.654H0v2.292H18.41v2.489a3.438,3.438,0,1,0,2.292,0V29.945h18.41V27.654H36.821V6.875ZM19.556,36.821A1.146,1.146,0,1,1,20.7,35.675,1.147,1.147,0,0,1,19.556,36.821ZM2.292,2.292H36.821V4.583H2.292ZM34.529,27.654H4.583V6.875H34.529Z"
          transform="translate(321.279 382.167)"
          fill={`${color ?? "#12aac4"}`}
          stroke="#12aac4"
          strokeWidth="1"
        />
        <g
          id="Ellipse_272"
          data-name="Ellipse 272"
          transform="translate(346 401)"
          fill="#edf4fd"
          stroke="#12aac4"
          strokeWidth="2"
        >
          <ellipse cx="12" cy="11.5" rx="12" ry="11.5" stroke="none" />
          <ellipse cx="12" cy="11.5" rx="11" ry="10.5" fill="none" />
        </g>
        <text
          id="_"
          data-name="+"
          transform={
            Lang.getLanguage() === "ar"
              ? "translate(363 417.50)"
              : "translate(352 417)"
          }
          fill={`${color ?? "#12aac4"}`}
          fontSize="16"
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </g>
    </svg>
  </div>
);

export const projectsIconEdit = (
  color,
  iconWidth,
  iconHeight,
  containerStyle
) => (
  <div className={`d-flex ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${iconWidth ?? "60.154"}`}
      height={`${iconHeight ?? "60.314"}`}
      viewBox="0 0 49.221 42.333"
    >
      <g
        id="Group_305"
        data-name="Group 305"
        transform="translate(-320.779 -381.667)"
      >
        <path
          id="projection-screen"
          d="M39.112,6.875V0H0V6.875H2.292V27.654H0v2.292H18.41v2.489a3.438,3.438,0,1,0,2.292,0V29.945h18.41V27.654H36.821V6.875ZM19.556,36.821A1.146,1.146,0,1,1,20.7,35.675,1.147,1.147,0,0,1,19.556,36.821ZM2.292,2.292H36.821V4.583H2.292ZM34.529,27.654H4.583V6.875H34.529Z"
          transform="translate(321.279 382.167)"
          fill={`${color ?? "#12aac4"}`}
          stroke="#12aac4"
          strokeWidth="1"
        />
        <g
          id="Ellipse_272"
          data-name="Ellipse 272"
          transform="translate(346 401)"
          fill="#edf4fd"
          stroke="#12aac4"
          strokeWidth="2"
        >
          <ellipse cx="12" cy="11.5" rx="12" ry="11.5" stroke="none" />
          <ellipse cx="12" cy="11.5" rx="11" ry="10.5" fill="none" />
        </g>
        <text
          id="_"
          data-name="+"
          transform={
            Lang.getLanguage() === "ar"
              ? "translate(362 422.50)"
              : "translate(352 417)"
          }
          fill={`${color ?? "#12aac4"}`}
          fontSize="16"
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            *
          </tspan>
        </text>
      </g>
    </svg>
  </div>
);

export const statusIcon = (color, iconWidth, iconHeight, containerStyle) => (
  <div className={`${styleEnd("m", 2)} ${containerStyle}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${iconWidth ?? "18"}`}
      height={`${iconHeight ?? "18"}`}
      viewBox="0 0 18 18"
    >
      <g
        id="technical-support_1_"
        data-name="technical-support (1)"
        transform="translate(0 0.001)"
      >
        <path
          id="Path_428"
          data-name="Path 428"
          d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
          transform="translate(0)"
          fill={color ?? "#000"}
        ></path>
        <path
          id="Path_429"
          data-name="Path 429"
          d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
          transform="translate(-190.541 -30.925)"
          fill={color ?? "#000"}
        ></path>
        <path
          id="Path_430"
          data-name="Path 430"
          d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
          transform="translate(-71.384 -71.399)"
          fill={color ?? "#000"}
        ></path>
        <path
          id="Path_431"
          data-name="Path 431"
          d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
          transform="translate(-167.277 -167.277)"
          fill={color ?? "#000"}
        ></path>
        <path
          id="Path_432"
          data-name="Path 432"
          d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
          transform="translate(-326.193 -17.183)"
          fill={color ?? "#000"}
        ></path>
        <path
          id="Path_433"
          data-name="Path 433"
          d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
          transform="translate(-148.933 -457.683)"
          fill={color ?? "#000"}
        ></path>
      </g>
    </svg>
  </div>
);
export const CommentsIcon = () => {
  return (
    <svg
      id="fi-br-comment-alt"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 15.851"
    >
      <path
        id="Path_74"
        data-name="Path 74"
        d="M12.333,0H3.667A3.671,3.671,0,0,0,0,3.667v6a3.671,3.671,0,0,0,3.667,3.667h.959l2.733,2.285a1,1,0,0,0,1.283,0l2.733-2.285h.959A3.671,3.671,0,0,0,16,9.667v-6A3.671,3.671,0,0,0,12.333,0ZM14,9.667a1.667,1.667,0,0,1-1.667,1.667H11.011a1,1,0,0,0-.641.233L8,13.548,5.63,11.567a1,1,0,0,0-.641-.233H3.667A1.667,1.667,0,0,1,2,9.667v-6A1.667,1.667,0,0,1,3.667,2h8.667A1.667,1.667,0,0,1,14,3.667Z"
        fill="black"
      />
      <path
        id="Path_75"
        data-name="Path 75"
        d="M7.167,8.333H9.5A1.167,1.167,0,0,0,9.5,6H7.167a1.167,1.167,0,0,0,0,2.333Z"
        transform="translate(-2.667 -2.289)"
        fill="black"
      />
      <path
        id="Path_76"
        data-name="Path 76"
        d="M14.853,11H7.265a1.265,1.265,0,0,0,0,2.529h7.588a1.265,1.265,0,0,0,0-2.529Z"
        transform="translate(-3 -3.196)"
        fill="black"
      />
    </svg>
  );
};

export function LogoutIcon({ width = 50, height = 50, color = "#1a73e8" }) {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      data-prefix="fas"
      data-icon="sign-out-alt"
      className="svg-inline--fa fa-sign-out-alt fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
      />
    </svg>
  );
}

export function EditPencile({
  width = 20,
  height = 20,
  color = "#1a73e8",
  onClick,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      className="mirror"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <path
        fill={color}
        d="M421.7 220.3L188.5 453.4L154.6 419.5L158.1 416H112C103.2 416 96 408.8 96 400V353.9L92.51 357.4C87.78 362.2 84.31 368 82.42 374.4L59.44 452.6L137.6 429.6C143.1 427.7 149.8 424.2 154.6 419.5L188.5 453.4C178.1 463.8 165.2 471.5 151.1 475.6L30.77 511C22.35 513.5 13.24 511.2 7.03 504.1C.8198 498.8-1.502 489.7 .976 481.2L36.37 360.9C40.53 346.8 48.16 333.9 58.57 323.5L291.7 90.34L421.7 220.3zM492.7 58.75C517.7 83.74 517.7 124.3 492.7 149.3L444.3 197.7L314.3 67.72L362.7 19.32C387.7-5.678 428.3-5.678 453.3 19.32L492.7 58.75z"
      />
    </svg>
  );
}
